import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Novaplaza';

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router
    ) {}

    // subscription: Subscription;

  ngOnInit() {
    /** spinner starts on init */
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
      // console.log('scroll in app.component');
      window.scrollTo(300, 0)
    }, 5000);
    
    
    // window.scrollTo(0,0);
    // window.screenTop = window.scrollY;
    
    // console.log(window.screenY);
    // this.subscription = this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe(() => window.scrollTo(0,0));
    
  }

  // ngOnDestroy(){
  //   console.log(window.screenY);
  //   this.subscription.unsubscribe();
  // }
  

  // ngAfterContentInit(){
  //   window.scrollTo(0,0);
  //   console.log(window);
  // }

}
